export const SHOW_PROCESS_STATEMENT_COMMENTS_SUCCESS = 'SHOW_PROCESS_STATEMENT_COMMENTS_SUCCESS';

export const showProcessStatementCommentsSuccess = processStatement => ({
    type: SHOW_PROCESS_STATEMENT_COMMENTS_SUCCESS,
    payload: { processStatement },
});
